import { forwardRef } from 'react'
import { ApparelProduct } from '@components/ApparelProduct/ApparelProduct'
import * as S from './ComplementaryProductsContainer.styles'
import type { ComplementaryProductsContainerProps } from './ComplementaryProductsContainer.types'

export const ComplementaryProductsContainer = forwardRef<
  HTMLDivElement,
  ComplementaryProductsContainerProps
>(
  (
    {
      products,
      onQuickAdd,
      showProductType = false,
      onAddToCart,
      allowQuickAdd = true,
      dataTestId,
      loading = false,
      layout = 'standard',
      shouldOpenCartDrawerOnAddToCart,
      productListRef,
    },
    ref,
  ) => {
    const apparelLayout =
      layout === 'condensed'
        ? 'condensed-list'
        : layout === 'ultra-condensed'
          ? 'ultra-condensed-list'
          : 'list'

    return (
      <S.ComplementaryProductsContainer ref={ref} data-testid={dataTestId}>
        {loading
          ? [...Array(2).keys()].map((id) => (
              <ApparelProduct loading layout={apparelLayout} key={id} />
            ))
          : products?.map(
              ({
                id,
                productType,
                title: productTitle,
                variants,
                sizes,
                isGiftCard,
                collectionBrandID,
                storeExclusive,
              }) => {
                return (
                  <ApparelProduct
                    disableBranding
                    key={id}
                    layout={apparelLayout}
                    isQuickAdd={allowQuickAdd}
                    showProductType={showProductType}
                    productType={productType}
                    title={productTitle}
                    variants={variants}
                    defaultSelected={0}
                    sizes={sizes}
                    isGiftCard={isGiftCard}
                    collectionBrandID={collectionBrandID}
                    storeExclusive={storeExclusive}
                    productListRef={productListRef}
                    shouldOpenCartDrawerOnAddToCart={
                      shouldOpenCartDrawerOnAddToCart
                    }
                    onQuickAdd={onQuickAdd}
                    onAddToCart={onAddToCart}
                  />
                )
              },
            )}
      </S.ComplementaryProductsContainer>
    )
  },
)

ComplementaryProductsContainer.displayName = 'ComplementaryProductsContainer'
